import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//services
import { EmployeeInfoService } from 'src/app/core/services/employee-info.service';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { TimeoutService } from 'src/app/core/services/timeout.service';

@Component({
  selector: 'app-note-detail-action-modal',
  templateUrl: './note-detail-action-modal.component.html',
  styleUrls: ['./note-detail-action-modal.component.css']
})
export class NoteDetailActionModalComponent implements OnInit {
  @Input() data: any;
  @Input() viewMode: boolean;
  formData: { [key: string]: any } = {};
  updatingTimeout: boolean = false;
  employeeInfo: any;
  noteList: any[];
  lastSave: { [key: string]: any } = {};
  saveText: string;

  constructor(employeeInfoService: EmployeeInfoService, private hiringService: HiringService, private utilityService: UtilityService, public activeModal: NgbActiveModal, private timeoutService: TimeoutService) {
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {
    this.getNote();
  }

  getNote() {
    this.hiringService.applicantNotesGet(this.data.OnboardID).then((response: any) => {
      this.noteList = response;
    });
  }

  editNote(data: any) {
    data.editing = !data.editing;
  }

  saveEdit(data: any) {
    this.hiringService.applicantNotesAddEdit(this.data.OnboardID, data.NoteText, this.data.ReqID, data.ReqApplicantNoteID).then((response: any) => {
      this.fadeLabel(response.success);
      data.editing = false;
    });
  }

  addClicked() {
    this.hiringService.applicantNotesAddEdit(this.data.OnboardID, this.formData.newNote, this.data.ReqID, -1).then((response: any) => {
      this.formData.newNote = null;
      this.fadeLabel(response.success);
      this.getNote();
    });
  }

  updateTimeout() {
    if (!this.timeoutService.getRefreshingTimeout()) {
      var lastActivityTime = this.timeoutService.getLastActivityTime();
      var timeoutConfig = this.timeoutService.getTimeoutConfig();
      if (timeoutConfig - lastActivityTime < 10) {
        this.timeoutService.refreshTimeout();
      }
    }
  }

  removeNote(data: any) {
    data.remove = true;
  }

  removeNoteCancel(data: any) {
    data.remove = false;
  }

  removeNoteConfirm(data: any) {
    this.hiringService.applicantNotesRemove(this.data.OnboardID, data.ReqApplicantNoteID).then((response: any) => {
      this.fadeLabel(response.success);
      this.getNote();
    });
  }

  closeClicked() {
    this.activeModal.dismiss();
  };

  fadeLabel(status: any, text?: string) {
    this.formData.labelFade = false;
    this.lastSave = this.utilityService.fadeLabel(status);
    this.saveText = text;
    setTimeout(() => {
      this.formData.labelFade = true;
    }, 2000);
  }

}
